/* iceberg-ui */
import { Icon, LoadingSpinner, SpinnerSize } from '@auviknetworks/iceberg-ui';
import { Box, Button, Typography } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ManagedTableNewData = ({
    newDataAvailable,
    newDataLoading,
    onRefresh
}) => {
    const { t } = useTranslation();
    return (
        <Box
            flex={1}
            display="flex"
            alignItems="center"
            gap="8px"
            marginLeft="auto"
            justifyContent="flex-end"
        >
            <Box display="flex" sx={{ color: 'icon.primary' }}>
                {newDataAvailable && <Icon size="24px" src="WarningTriangle" />}
                {newDataLoading && <LoadingSpinner size={SpinnerSize.BUTTON} />}
            </Box>
            <Box>
                <Typography color="textPrimary">
                    {newDataAvailable && t('ManagedTable.newData.available')}
                    {newDataLoading && t('ManagedTable.newData.loading')}
                </Typography>
            </Box>
            <Box display="flex" alignItems="center">
                {newDataAvailable && (
                    <Button
                        data-testid="managedTableRefreshBtn"
                        data-trackid="managedTableRefreshBtn"
                        variant="outlined"
                        size="anmSmall"
                        onClick={onRefresh}
                    >
                        {t('Common.refresh')}
                    </Button>
                )}
            </Box>
        </Box>
    );
};
